var Logo = require('./logo');

module.exports = Logo;

function Icon () {}
Icon.prototype = new Logo();
Icon.prototype.constructor = Icon;
